/*
  LHR Produktbewertungen: laedt echte Judge.me-Produktbewertungen (oeffentlicher CDN-Endpunkt
  reviews_for_widget) und zeigt sie als Karten im Kundenstimmen-Design (sections/lhr-judgeme-reviews.liquid).
  Texte werden als reiner Text eingesetzt. Bewertungen ohne Text bekommen keine Karte, zaehlen aber
  in der Gesamtzahl. Ohne Bewertungen oder bei Fehlern bleibt die Section unsichtbar und das Judge.me-Widget
  unveraendert sichtbar.
*/
(function () {
  'use strict';
  var COLORS = ['#ffc081', '#9aee7d', '#a6e3ce', '#d7bce2', '#a6e6ff'];

  // Kompakte Karten am Handy (wie am Desktop: schmaler, mit Blick auf die naechste Karte).
  var mobileCss = document.createElement('style');
  mobileCss.textContent = '@media (max-width: 989px){' +
    '.lhr-rv .lhr-rv__track{gap:1.25rem}' +
    '.lhr-rv .lhr-rv__slide{flex-basis:78%}' +
    '.lhr-rv .card__surface{padding:1rem}' +
    '.lhr-rv .testimonials__quote-svg-container{margin-bottom:.6rem}' +
    '.lhr-rv .testimonials__quote-svg-container svg{width:34px;height:22px}' +
    '.lhr-rv .lhr-rv__text{font-size:.95rem;line-height:1.45;-webkit-line-clamp:5}' +
    '.lhr-rv .lhr-rv__avatar{width:36px;height:36px;flex-basis:36px;font-size:.95rem}' +
    '.lhr-rv .lhr-rv__meta{font-size:.75rem}' +
    '.lhr-rv .tracking-rating{font-size:.8rem}' +
    '.lhr-rv .lhr-rv__summary{font-size:1rem}' +
    '.lhr-rv .lhr-rv__nav .push-btn__surface{padding:12px}' +
    '.lhr-rv .lhr-rv__all{font-size:.85rem;padding:.55rem 1rem}}';
  document.head.appendChild(mobileCss);

  function widgetSection() {
    var w = document.querySelector('.jdgm-review-widget, [data-jdgm-review-widget], .jdgm-rev-widg');
    return w ? w.closest('.shopify-section') : null;
  }
  function plain(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return (d.textContent || '').trim(); }
  function stars(n) { n = Math.max(0, Math.min(5, Math.round(n))); return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n); }
  function date(iso) { try { return new Date(iso).toLocaleDateString('de-DE'); } catch (e) { return ''; } }

  function wireWidget(root) {
    var toggle = root.querySelector('[data-lhr-rv-toggle]');
    var tries = 0;
    (function attach() {
      var ws = widgetSection();
      if (!ws && tries++ < 20) return setTimeout(attach, 500);
      if (ws && root.dataset.collapseWidget === 'true') {
        ws.classList.add('lhr-jdgm-collapsed');
        if (toggle) toggle.addEventListener('click', function () {
          var open = !ws.classList.toggle('lhr-jdgm-collapsed');
          toggle.setAttribute('aria-expanded', String(open));
          if (open) ws.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      } else if (toggle) {
        toggle.addEventListener('click', function () { if (ws) ws.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      }
    })();
  }

  function build(root, data) {
    var reviews = (data && data.reviews) || [];
    var track = root.querySelector('[data-lhr-rv-track]');
    var tpl = root.querySelector('[data-lhr-rv-card]');
    var shown = 0;
    reviews.forEach(function (r) {
      var title = plain(r.title), body = plain(r.body_html);
      if (!body && !title) return;
      if (!body) { body = title; title = ''; }
      var li = tpl.content.firstElementChild.cloneNode(true);
      li.querySelector('.card__surface').style.backgroundColor = COLORS[shown % COLORS.length];
      var set = function (f, v) { var el = li.querySelector('[data-f="' + f + '"]'); if (el) el.textContent = v; return el; };
      if (!title || body.indexOf(title) === 0) li.querySelector('[data-f="title"]').remove(); else set('title', title);
      set('body', '„' + body + '“');
      set('name', r.reviewer_name || 'Kunde');
      set('initial', (r.reviewer_initial || (r.reviewer_name || '?').charAt(0)).toUpperCase());
      set('meta', (r.verified_buyer ? '✓ Verifizierter Kauf · ' : '') + date(r.created_at));
      set('stars', stars(r.rating)).setAttribute('aria-label', r.rating + ' von 5 Sternen');
      track.appendChild(li);
      shown++;
    });
    if (!shown) return;

    var avg = parseFloat(data.average_rating || 0).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    var n = data.number_of_reviews || shown;
    root.querySelector('[data-lhr-rv-summary]').textContent = avg + ' von 5 · ' + n + (n === 1 ? ' Bewertung' : ' Bewertungen');
    root.hidden = false;

    // Endloses, langsames Laufband wie das Kundenstimmen-Karussell der Startseite:
    // Karten einmal duplizieren, scrollLeft gleichmaessig erhoehen und nach einer Runde zuruecksetzen.
    var originals = [].slice.call(track.children);
    function addCopy() { originals.forEach(function (li) { var c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); }); }
    if (shown > 1) { addCopy(); for (var k = 0; k < 6 && track.scrollWidth < track.clientWidth + (track.children[shown].offsetLeft - track.children[0].offsetLeft); k++) addCopy(); }
    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';
    var SPEED = parseFloat(root.dataset.speed) || 30; // Pixel pro Sekunde
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hover = false, holdUntil = 0, visible = true, pos = track.scrollLeft, last = 0;
    function loopWidth() { var c = track.children[shown]; return c ? c.offsetLeft - track.children[0].offsetLeft : 0; }
    function hold(ms) { holdUntil = Date.now() + ms; }
    function frame(t) {
      var dt = last ? Math.min((t - last) / 1000, 0.1) : 0; last = t;
      var lw = loopWidth();
      if (shown > 1 && !reduce && visible && !hover && Date.now() > holdUntil && !document.hidden && lw > 0) {
        pos += SPEED * dt;
        if (pos >= lw) pos -= lw;
        track.scrollLeft = pos;
      } else {
        pos = track.scrollLeft;
        if (lw > 0 && pos >= lw) { pos -= lw; track.scrollLeft = pos; }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    track.addEventListener('mouseenter', function () { hover = true; });
    track.addEventListener('mouseleave', function () { hover = false; pos = track.scrollLeft; });
    track.addEventListener('touchstart', function () { hold(4000); }, { passive: true });
    track.addEventListener('touchmove', function () { hold(4000); }, { passive: true });
    track.addEventListener('focusin', function () { hold(6000); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(track);

    var step = function (dir) {
      hold(2500);
      var slide = track.querySelector('.lhr-rv__slide');
      var w = slide ? slide.getBoundingClientRect().width + 40 : track.clientWidth;
      var target = track.scrollLeft + dir * w, lw = loopWidth();
      if (target < 0 && lw) { track.scrollLeft += lw; target += lw; }
      track.scrollTo({ left: target, behavior: 'smooth' });
    };
    root.querySelector('[data-lhr-rv-prev]').addEventListener('click', function () { step(-1); });
    root.querySelector('[data-lhr-rv-next]').addEventListener('click', function () { step(1); });
    if (shown < 2) root.querySelectorAll('[data-lhr-rv-prev],[data-lhr-rv-next]').forEach(function (b) { b.style.visibility = 'hidden'; });

    wireWidget(root);
  }

  function load(root) {
    var url = 'https://cdn.judge.me/reviews/reviews_for_widget?product_id=' + root.dataset.productId +
      '&page=1&sort_by=created_at&sort_dir=desc&per_page=' + (parseInt(root.dataset.max, 10) || 12) +
      '&translation_locale=de&widget_theme=carousel&shop_domain=' + encodeURIComponent(root.dataset.shop) + '&platform=shopify';
    fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) { build(root, d); }).catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-lhr-reviews]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      if (!('IntersectionObserver' in window)) return load(root);
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); load(root); } }, { rootMargin: '600px' });
      io.observe(root.parentElement || root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
